module.exports = __webpack_public_path__ + "static/media/header_palmsbet.98d91bac.png";